<template>
  <div id="welcome-modal-continue" class="mt-8 px-2">
    <h1 class="my-2" :class="{ 'white--text': $vuetify.theme.dark }">
      {{ $t('views.welcomeModal.welcomeModalContinue.hello') }}
    </h1>
    <div class="my-3">
      <div class="mt-4 subtitle">
        {{ $t('views.welcomeModal.welcomeModalContinue.subtitle') }}
      </div>

      <div class="add-broker-card mt-6 pa-5 pt-7" @click="start">
        <v-icon size="18" color="primary">mdi-bank</v-icon>
        <div class="mt-2">
          {{ $t('views.welcomeModal.welcomeModalContinue.addBroker') }}
        </div>
      </div>

      <div class="mt-6 pt-6">
        {{ $t('views.welcomeModal.welcomeModalContinue.tutorials') }}
        <a href="https://www.filios.app/tutoriales" target="_blank">
          {{ $t('views.welcomeModal.welcomeModalContinue.showTutorials') }}
          <v-icon size="13" color="primary">mdi-open-in-new</v-icon>
        </a>
      </div>
      <div class="mt-3">
        {{ $t('views.welcomeModal.welcomeModalContinue.contact1') }}
        <a href="https://www.filios.app/contacta" target="_blank">
          {{ $t('views.welcomeModal.welcomeModalContinue.contact2') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import gtag from '@/lib/gtag'

export default {
  computed: {
    ...mapState(['user']),
  },
  methods: {
    start() {
      this.$emit('start')

      gtag.pageview({
        pagePath: `/welcome/start`,
        pageTitle: `welcome|start`,
        pageContentGroup: 'modal',
      })
    },
  },
}
</script>

<style lang="scss">
#welcome-modal-continue {
  font-size: 13px;
  a {
    text-decoration: none;
  }
  .subtitle {
    font-size: 15px;
  }
  .add-broker-card {
    height: 160px;
    width: 160px;
    border-radius: 20px;
    cursor: pointer;
    font-size: 14px;
    line-height: 1.7;
    color: #2597fe;
    font-weight: 400;

    background-color: white;
    border: 1px solid #eeeeee;
    &:hover {
      background-color: #f7f8fb;
      border: 1px solid #999;
    }
  }
}
.theme--dark #welcome-modal-continue {
  .add-broker-card {
    background-color: #323940;
    border: 1px solid #5b5b5b;
    &:hover {
      background-color: #3b444c;
      border: 1px solid #a5a5a5;
    }
  }
}
</style>
